"use client";

import { useEffect, useRef } from "react";
import { sendCAPIEvent } from "@/lib/meta-capi";

interface Props {
  contentName: string;
  contentCategory: string;
  contentIds: string;
}

export default function ViewContentTracker({ contentName, contentCategory, contentIds }: Props) {
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;

    const eventId = crypto.randomUUID();

    window.fbq?.(
      "track",
      "ViewContent",
      {
        content_name: contentName,
        content_category: contentCategory,
        content_ids: [contentIds],
        content_type: "product",
      },
      { eventID: eventId },
    );

    sendCAPIEvent({
      event_name: "ViewContent",
      event_id: eventId,
      event_source_url: window.location.href,
      custom_data: {
        content_name: contentName,
        content_category: contentCategory,
        content_ids: [contentIds],
        content_type: "product",
      },
    });
  }, [contentName, contentCategory, contentIds]);

  return null;
}
